import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class ArbitrosService {

  constructor(private http: HttpClient) { }

  public obtenerListaArbitros(paginator){
    return this.http.get(GlobalVariable.API_SERVER_URL+"arbitros/empresa/"+paginator.filter.id_empresa+
      "/tipo/"+(paginator.filter.tipo && paginator.filter.tipo.id?paginator.filter.tipo.id:0)+
      "/disciplina/"+(paginator.filter.disciplina && paginator.filter.disciplina.id?paginator.filter.disciplina.id:0)+
      "/pagina/"+paginator.currentPage+"/items-pagina/"+paginator.itemsPerPage+
      "/busqueda/"+paginator.search+"/columna/"+paginator.column+"/direccion/"+paginator.direction,
      GlobalVariable.httpOptions);
  }

  public guardarArbitro(arbitro){
    return this.http.post(GlobalVariable.API_SERVER_URL+"arbitros",arbitro,GlobalVariable.httpOptions);
  }

  public actualizarArbitro(arbitro){
    return this.http.put(GlobalVariable.API_SERVER_URL+"arbitros/"+arbitro.id,arbitro,GlobalVariable.httpOptions);
  }

  public eliminarArbitro(arbitro){
    return this.http.delete(GlobalVariable.API_SERVER_URL+"arbitros/"+arbitro.id,GlobalVariable.httpOptions);
  }
}
